<app-basket-item
*ngFor="let cartItem of basket; let i = index"
  [basketItem]="cartItem"></app-basket-item>